import { render, staticRenderFns } from "./CreateTrackingCategoryPopupFlow.vue?vue&type=template&id=e28c8eb4&scoped=true"
import script from "./CreateTrackingCategoryPopupFlow.vue?vue&type=script&lang=js"
export * from "./CreateTrackingCategoryPopupFlow.vue?vue&type=script&lang=js"
import style0 from "./CreateTrackingCategoryPopupFlow.vue?vue&type=style&index=0&id=e28c8eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28c8eb4",
  null
  
)

export default component.exports